module.exports = __webpack_public_path__ + "static/img/2025年历-9.086ff3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-9.png
// module id = lsI6
// module chunks = 3